// Club House = portail membre + back-office, monté sous /clubhouse.
// La vitrine (ResortApp) est montée à la racine du domaine.
export const CLUBHOUSE_BASE = '/clubhouse';

// Domaines « 100 % Club House » (transition bassgolf.fr) : la racine renvoie vers /clubhouse.
export const CLUBHOUSE_ROOT_HOSTS = ['bassgolf.fr', 'www.bassgolf.fr'];

// Pages de la vitrine (1 seul segment) — tout autre chemin hors /clubhouse est une ancienne adresse du Club House.
export const VITRINE_PAGES = ['golf', 'hotel', 'restaurant', 'spa', 'academie', 'evenements', 'actualites', 'espace-club', 'reserver'];

export function clubPath(path = '/') {
  const p = String(path || '/');
  if (p === '/' || p === '') return CLUBHOUSE_BASE;
  if (p === CLUBHOUSE_BASE || p.startsWith(`${CLUBHOUSE_BASE}/`) || p.startsWith(`${CLUBHOUSE_BASE}?`)) return p;
  return `${CLUBHOUSE_BASE}${p.startsWith('/') ? '' : '/'}${p}`;
}

export function clubUrl(path = '/') {
  return `${window.location.origin}${clubPath(path)}`;
}

// Chemin courant sans le préfixe /clubhouse (équivalent de l'ancien window.location.pathname).
export function appPathname() {
  const p = window.location.pathname;
  if (p === CLUBHOUSE_BASE) return '/';
  if (p.startsWith(`${CLUBHOUSE_BASE}/`)) return p.slice(CLUBHOUSE_BASE.length);
  return p;
}

const stripResort = (path) => path.slice('/resort'.length) || '/';

// Décide, à partir de l'URL d'arrivée, quelle application afficher et si l'URL doit être réécrite.
// Retour : { mode: 'clubhouse' | 'vitrine', rewrite?: string, external?: string }
export function resolveEntry(loc = window.location) {
  const host = (loc.hostname || '').toLowerCase();
  const path = (loc.pathname || '/').replace(/\/{2,}/g, '/');
  const tail = `${loc.search || ''}${loc.hash || ''}`;

  if (path === CLUBHOUSE_BASE || path.startsWith(`${CLUBHOUSE_BASE}/`)) {
    const inner = path.slice(CLUBHOUSE_BASE.length) || '/';
    // Anciennes adresses bassgolf.fr/api/* et /resort/* redirigées par le registrar vers /clubhouse/*
    if (inner === '/api' || inner.startsWith('/api/')) return { mode: 'clubhouse', external: `${inner}${tail}` };
    if (inner === '/resort' || inner.startsWith('/resort/')) return { mode: 'vitrine', rewrite: `${stripResort(inner)}${tail}` };
    return { mode: 'clubhouse' };
  }

  if (path === '/resort' || path.startsWith('/resort/')) return { mode: 'vitrine', rewrite: `${stripResort(path)}${tail}` };

  const segs = path.split('/').filter(Boolean);
  const isClubHost = CLUBHOUSE_ROOT_HOSTS.includes(host);
  const isVitrinePath = segs.length === 0 || (segs.length === 1 && VITRINE_PAGES.includes(segs[0]));
  if (!isClubHost && isVitrinePath) return { mode: 'vitrine' };

  return { mode: 'clubhouse', rewrite: `${CLUBHOUSE_BASE}${path === '/' ? '' : path}${tail}` };
}
